import cn from 'classnames';

import styles from './Picture.module.css';

export type PictureProps = {
    images: string[];
    alt: string;
    className?: string;
    imageClassName?: string;
};

export const Picture = ({
    images,
    alt,
    className,
    imageClassName,
}: PictureProps) => {
    if (!images.length) {
        return null;
    }

    if (images.length === 1) {
        return (
            <img
                src={images[0]}
                alt={alt}
                className={cn(styles.image, imageClassName)}
            />
        );
    }

    const [fallbackSrc, ...sources] = images;

    return (
        <picture className={cn(styles.picture, className)}>
            {sources.map((src, index) => (
                <source key={index} srcSet={src} />
            ))}
            <img
                src={fallbackSrc}
                alt={alt}
                className={cn(styles.image, imageClassName)}
            />
        </picture>
    );
};
